<template>
  <!-- Flex child of .form-main-body. Leftover clip only when parent has --fill (1084). -->
  <div class="multiple-main-root">
    <FormSection v-if="mainTabs.length === 1" :data="mainTabs[0]" />
    <template v-else>
      <div v-if="orientation === 'horizontal'" class="multiple-main-row">
        <div
          v-for="(main, i) in mainTabs"
          :key="i"
          class="multiple-main-col"
          :style="horizontalColStyle(i)"
        >
          <FormSection :data="main" />
        </div>
      </div>
      <template v-else>
        <div v-for="(main, i) in mainTabs" :key="i" class="multiple-main-stack-row">
          <div class="multiple-main-stack-col">
            <FormSection :data="main" />
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import FormSection from './Section.vue';

interface Props {
  mainTabs: any[];
  cols: number[];
  orientation: string;
}

const props = withDefaults(defineProps<Props>(), {
  mainTabs: () => [],
  cols: () => [],
  orientation: '',
});

function horizontalColStyle(index: number): Record<string, string> {
  const raw = props.cols[index];
  const n =
    typeof raw === 'number' && Number.isFinite(raw) && raw > 0
      ? raw
      : 100 / Math.max(1, props.mainTabs.length);
  return {
    flex: `0 0 ${n}%`,
    maxWidth: `${n}%`,
    minWidth: '0',
    boxSizing: 'border-box',
  };
}
</script>

<style scoped lang="scss">
.multiple-main-root {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.multiple-main-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 100%;
}

.multiple-main-col {
  min-width: 0;
}

.multiple-main-stack-row {
  width: 100%;
  margin-bottom: 0.75rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.multiple-main-stack-col {
  width: 100%;
}
</style>
